import { render, staticRenderFns } from "./BillingSettings.vue?vue&type=template&id=13fffcf2&scoped=true&lang=pug&"
import script from "./BillingSettings.vue?vue&type=script&lang=js&"
export * from "./BillingSettings.vue?vue&type=script&lang=js&"
import style0 from "./BillingSettings.vue?vue&type=style&index=0&id=13fffcf2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fffcf2",
  null
  
)

/* custom blocks */
import block0 from "./BillingSettings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports